import { render, staticRenderFns } from "./TimeSlotSelectionView.vue?vue&type=template&id=b5dd9648&"
import script from "./TimeSlotSelectionView.vue?vue&type=script&lang=ts&"
export * from "./TimeSlotSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./TimeSlotSelectionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5dd9648')) {
      api.createRecord('b5dd9648', component.options)
    } else {
      api.reload('b5dd9648', component.options)
    }
    module.hot.accept("./TimeSlotSelectionView.vue?vue&type=template&id=b5dd9648&", function () {
      api.rerender('b5dd9648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TimeSlotSelectionView.vue"
export default component.exports